import { CommonModule } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastService } from '../../../../services/toast-service';
import { Document } from '../../../../shared/document-directive';
import { DocumentTableComponent } from '../../../../shared/document-table-component/document-table-component';
import { DocumentItem, IngestionDto } from '../../../../shared/interfaces';
import { DuplicatesActionModalComponent } from '../to-process/duplicates-action-modal/duplicates-action-modal.component';
import { IngestionModalComponent } from '../to-process/ingestion-modal/ingestion-modal';
@Component({
  selector: 'app-in-error',
  standalone: true,
  imports: [CommonModule, DocumentTableComponent],
  templateUrl: './in-error.html',
  styleUrl: './in-error.scss',
})
export class InError extends Document {
  private readonly modalService = inject(NgbModal);
  private readonly toastService = inject(ToastService);

  // Impostazioni base
  status: string = 'error';
  task: string = 'trigger-scan';

  // Stati della modale di Errore
  isModalOpen = signal<boolean>(false);
  isFetchingError = signal<boolean>(false);
  errorDetailMessage = signal<string | null>(null);

  constructor() {
    super();
    
    this.currentPath.set('error/');
  }

  // --- LOGICA INGESTION ---

  openIngestionModal() {
    const index = this.rootFolderName();
    if (!index) return;
    const modalRef = this.modalService.open(IngestionModalComponent, { centered: true, windowClass: 'agentic-custom-modal' });
    modalRef.componentInstance.indexName = index;
    modalRef.result.then(res => res && this.confirmIngestion(res)).catch(() => {});
  }

  confirmIngestion(indexName: string) {
    const selectedDocs = this.selectedItems().map(doc => doc.percorso);

    const payload: IngestionDto = { 
      indexName: indexName,
      docs: selectedDocs,
      action: 'replace'
    };

    this.executeIngestion(payload);
  }

  private executeIngestion(payload: IngestionDto) {
    this.isLoading.set(true);

    this.documentService.ingestDocuments(this.task, payload).subscribe({
      next: (res) => {
        this.isLoading.set(false);
        
        if (res.status === 'DUPLICATES_FOUND' && res.conflicts) {
          this.handleDuplicatesModal(payload, res);
        } else {
          this.selectedItems.set([]); 
        }
      },
      error: () => this.isLoading.set(false)
    });
  }

  private handleDuplicatesModal(originalPayload: IngestionDto, res: any) {
    const modalRef = this.modalService.open(DuplicatesActionModalComponent, { 
      centered: true, 
      windowClass: 'agentic-custom-modal' 
    });

    modalRef.componentInstance.duplicatesList = res.conflicts;
    modalRef.componentInstance.conflictType = res.conflictType; 
    
    const totalDocsSent = originalPayload.docs?.length || 0;
    modalRef.componentInstance.allDuplicates = (totalDocsSent === res.conflicts.length);

    modalRef.result.then((userChoice: 'replace' | 'keep' | 'ignore' | 'cancel') => {
      if (!userChoice || userChoice === 'cancel') return; 

      if (userChoice === 'replace') {
        this.executeIngestion({ ...originalPayload, action: 'replace' });
      } else if (userChoice === 'keep') {
        this.executeIngestion({ ...originalPayload, action: 'keep' });
      } else if (userChoice === 'ignore') {
        
        // Estraiamo solo i path di ingresso per poterli filtrare dalla lista originale
        const duplicateIncomingPaths = new Set(res.conflicts.map((c: any) => c.incomingFile));
        const filteredDocs = originalPayload.docs?.filter(doc => !duplicateIncomingPaths.has(doc)) || [];
        
        if (filteredDocs.length === 0) {
          this.toastService.show('Tutti i file selezionati erano duplicati. Operazione ignorata.', 'info');
          this.selectedItems.set([]); 
          return;
        }
        
        this.executeIngestion({ ...originalPayload, docs: filteredDocs });
      }
    }).catch(() => {});
  }

  // --- LOGICA DETTAGLIO ERRORE ---

  openErrorDetail(document: DocumentItem) {
    if (!document.id) {
      this.errorDetailMessage.set('Impossibile recuperare il dettaglio: fileId mancante.');
      this.isModalOpen.set(true);
      return;
    }

    this.isModalOpen.set(true);
    this.isFetchingError.set(true);
    this.errorDetailMessage.set(null);

    this.documentService.getDocumentsDetail(document.id).subscribe({
      next: (response) => {
        this.errorDetailMessage.set(response.error || 'Nessun messaggio di errore specifico trovato nel database.');
        this.isFetchingError.set(false);
      },
      error: (errorResponse) => {
        console.error('Errore nel recupero dei dettagli:', errorResponse.error.message);
        this.errorDetailMessage.set('Errore nel recupero dei dettagli: ' + errorResponse.error.message);
        this.isFetchingError.set(false);
      }
    });
  }

  closeModal() {
    this.isModalOpen.set(false);
  }
}